import { useGlobalPermissions } from '@lopo-tech/lopo-api'

import { AuthorizationReason, hasAuthorizationReason } from 'src/utils/authorization_reasons'

export const useIsBlogProfileFeatureDisabled = () => {
  const permissions = useGlobalPermissions()
  return (
    !permissions.canCreateBlogProfile &&
    hasAuthorizationReason(
      permissions.data?.globalPermissions.canCreateBlogProfile.reasons?.details,
      AuthorizationReason.FEATURE_DISABLED
    )
  )
}
